export default {
    BusinessAfterCsgReturn: {
        main: {
            outRefundNo: 'Return Order No.',
            returnOrderDate: 'Return Date',
            totalQty: 'Total Quantity',
            orderStatus: 'Status',
            backInventoryQty: 'Return quantity',
            backInventoryRemark: 'Return comments',
            damagedQty: 'Disposal quantity',
            damagedRemark: 'Disposal comments',
            comment: 'Comment',
            thirdOrder: 'Third-party platform ID',
        },

        table: {
            add: 'Add Returned Products',
            cusName: 'Customer',
            reference: 'Reference',
            checkCounts: 'Check Counts',
            skuStatus: 'Sku Status',
            backInventoryQty: 'Quantity Back Inventory',
            backInventoryRemark: 'Back Inventory Comment',
            damagedQty: 'Quantity Damaged',
            damagedRemark: 'Damaged Comment'
        },

        uploadHindText1: 'Attention',
        uploadHindText2: 'At least upload 3 images',
        barCodeText: 'Please enter the BarCode',
        hintMessageText1: 'Please select a customer first.',
        hintMessageText2: 'Please add the returned product.',
        hintMessageText3: 'Please upload at least 3 images.',
        hintMessageText4: 'Please complete the returned product information.',
        damageTitleText: 'Return order results',
        pictureMsg: 'Image Information',
        hintMessageText5: 'Total Quantity = Return quantity + Disposal quantity. Please fill in carefully!',
        information: 'Associated Information',
        imgTip: '3 images required'
    }
};
